import React from 'react';
import DailyBulletinTopContainer from 'components/organisms/DailyBulletinTopContainer';
import FilterProvider from 'providers/Filter';
import { GridProvider } from 'hooks/grid/useDailyBulletinGrid';
import dayjs from 'dayjs';
import DailyBulletinChartsContainer from 'components/organisms/DailyBulletinChartsContainer';
import DailyBulletinGridContainer from 'components/organisms/DailyBulletinGridContainer';
// import CorrectivesGridContainer from 'components/organisms/CorrectivesGridContainer';
import { Box } from '@material-ui/core';

const DailyBulletinPresentation = () => {
  const [updatedAt, setUpdatedAt] = React.useState<Date | null>(null);
  const initialState = React.useMemo(
    () => ({
      date: [{ label: dayjs().toString(), value: dayjs().toISOString() }],
    }),
    [],
  );

  return (
    <FilterProvider initialState={initialState}>
      <GridProvider>
        <DailyBulletinTopContainer />
        <Box
          style={{
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          <DailyBulletinChartsContainer updatedAt={updatedAt} />
          <DailyBulletinGridContainer setUpdatedAt={setUpdatedAt} />
        </Box>
        {/* <CorrectivesGridContainer setUpdatedAt={setUpdatedAt} /> */}
      </GridProvider>
    </FilterProvider>
  );
};

export default DailyBulletinPresentation;
